module.exports = __webpack_public_path__ + "static/media/angel.814a0abd.jpeg";